import { styled } from '@mui/material/styles';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';

type StyledScopedCssBaselineContainerCustomProps = {
  fullWidthView: boolean;
};

const StyledScopedCssBaselineContainer = styled(
  ScopedCssBaseline,
)<StyledScopedCssBaselineContainerCustomProps>((props) => {
  const { fullWidthView } = props;
  if (fullWidthView) {
    return {
      width: '100%',
    };
  } else {
    return {
      maxWidth: '768px',
      width: '100%',
      overflow: 'visible',
      margin: 'auto',
    };
  }
});

export default StyledScopedCssBaselineContainer;
